export default __webpack_public_path__ + "static/media/elalbergue3.a9ac47bc.jpg";